import React from 'react';
import { TextAreaStyle } from './textAreaStyles';

const TextArea = ({ ...props }) => {
  return <TextAreaStyle {...props} />;
};

export default TextArea;
